<template>
  <div class="jwl-video-player" v-if="videoFile.mimeType !== 'video/quicktime'">
    <video ref="videoPlayer">
      <source :src="videoFile.url" :type="videoFile.mimeType">
    </video>
  </div>
</template>

<script setup>
  import Plyr from 'plyr';

  const props = defineProps({
    videoFile: Object,
  });

  const videoPlayer = ref();
  const player = ref();

  onMounted(() => {
    player.value = new Plyr(videoPlayer.value);
  });
</script>

<style lang="scss">
@use 'plyr-style';

.jwl-video-player {
  margin-bottom: 2rem;
}
</style>
